import { render, staticRenderFns } from "./RamChart.vue?vue&type=template&id=6951fe28&scoped=true&"
import script from "./RamChart.vue?vue&type=script&lang=js&"
export * from "./RamChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6951fe28",
  null
  
)

export default component.exports